/* eslint-disable import/extensions */
/*
 *
 * Settlement Bank Details reducer
 *
 */
import produce from 'immer';
import moment from 'moment';
import { DEFAULT_DATE_TIME_PAYLOAD_FORMAT } from 'utils/constants';
import {
  DEFAULT_ACTION,
  ENABLE_LOADER,
  DISABLE_LOADER,
  SAVE_BANK_ACCOUNTS_RESPONSE,
  SAVE_REFUND_RECHARGE,
  RESET_REFUND_RECHARGE,
  RESET_DATA,
  ENABLE_MODAL_LOADER,
  DISABLE_MODAL_LOADER,
} from './constants';

const getInitialState = () => ({
  loaders: {
    isPageLoading: false,
    isModalLoading: false,
  },
  data: [],
  rechargeDetails: {},
  refundRechargeData: {
    loader: false,
    callRefundRechargeApi: true,
    startDate: moment()
      .subtract(6, 'months')
      .startOf('day')
      .format(DEFAULT_DATE_TIME_PAYLOAD_FORMAT),
    endDate: moment()
      .endOf('day')
      .format(DEFAULT_DATE_TIME_PAYLOAD_FORMAT),
    pageNo: 0,
    pageSize: 10,
    data: [],
  },
});

export const initialState = {
  ...getInitialState(),
};

/* eslint-disable default-case, no-param-reassign */
const settlementBankDetailsReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case ENABLE_LOADER: {
        if (action.data !== 'REFUND_RECHARGE')
          draft.loaders.isPageLoading = true;
        else draft.refundRechargeData.loader = true;
        break;
      }
      case DISABLE_LOADER: {
        if (action.data !== 'REFUND_RECHARGE')
          draft.loaders.isPageLoading = false;
        else draft.refundRechargeData.loader = false;
        break;
      }
      case ENABLE_MODAL_LOADER: {
        draft.loaders.isModalLoading = true;
        break;
      }
      case DISABLE_MODAL_LOADER: {
        draft.loaders.isModalLoading = false;
        break;
      }
      case SAVE_BANK_ACCOUNTS_RESPONSE: {
        const [
          settlementBankDetails,
          rechargeAmtDetails = {},
          rechargeBankDetails = {},
        ] = action.data;
        draft.data = settlementBankDetails;
        draft.rechargeDetails = {
          accountNumber: rechargeBankDetails.bankAccountNumber,
          accountHolder: rechargeBankDetails.accountHolderName,
          bankName: '',
          ifscCode: rechargeBankDetails.iFSCCode,
          rechargeamount: rechargeAmtDetails.rechargeamount,
        };
        draft.loaders.isPageLoading = false;
        break;
      }
      case SAVE_REFUND_RECHARGE: {
        const responseObj = action.data || {};
        if (
          responseObj.data &&
          responseObj.data.length < state.refundRechargeData.pageSize
        )
          draft.refundRechargeData.callRefundRechargeApi = false;
        if (responseObj.data)
          draft.refundRechargeData.data = [
            ...state.refundRechargeData.data,
            ...responseObj.data,
          ];
        draft.refundRechargeData.pageNo = responseObj.pageNo;
        draft.refundRechargeData.loader = false;
        draft.loaders.isPageLoading = false;
        break;
      }
      case RESET_REFUND_RECHARGE: {
        const obj = getInitialState().refundRechargeData;
        Object.keys(obj).forEach(k => (draft.refundRechargeData[k] = obj[k])); // eslint-disable-line
        break;
      }
      case RESET_DATA: {
        const obj = getInitialState();
        Object.keys(obj).forEach(k => (draft[k] = obj[k])); // eslint-disable-line
        break;
      }
      case DEFAULT_ACTION:
        break;
    }
  });

export default settlementBankDetailsReducer;
